/*
 *   Copyright (c) 2022 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 *   See License in the LICENSE file
 */
import * as React from "react";
// @ts-ignore
import { Script } from "gatsby";
import { orejimeConfig } from "./cookie-consent";
import Footer from "./footer/footer";
import Header, { HeaderProps } from "./header/header";
import "../styles/orejime.scss";

interface Props {
  pageTitle: string;
  children: any;
  pageContext: any;
  location: any;
}

const Layout = ({ pageTitle, children, type }: Props & HeaderProps) => {
  React.useEffect(() => {
    if (window) {
      (window as any).orejimeConfig = orejimeConfig;
    }
    document.body.classList.remove("modal-open");
  });
  return (
    <div id="app">
      <title>{pageTitle}</title>
      <Script src="https://unpkg.com/orejime@2.2.1/dist/orejime.js" />
      <main>
        <Header type={type}></Header>
        <div className="container mx-auto py-[60px]">{children}</div>
        <Footer></Footer>
      </main>
    </div>
  );
};

export default Layout;
